import React from "react";
import Card from 'react-bootstrap/Card';
import Seminario from '../../../assets/images/seminario.svg';
import RedeLocal from '../../../assets/images/redelocal.fw.png';
import './styles.css';


const IPs = () => {
    return(
        <div className="container-fluid">
            <div className="row">

                <div className="col-sm-12">
                    <Card className="card">

                        <div className="container">
                            <Card.Title><h1>Entendendo IPs Fixos, Dinâmicos e CGNAT: Guia para iniciantes</h1></Card.Title>

                            <Card.Body>
                                <div className="content-info">
                                    <div className="image-info">
                                        <img src={Seminario} alt="Foto" />
                                        <img src={RedeLocal} alt="Foto" />
                                    </div>
                                    <div className="info">

                                        <span>
                                            Quando você utiliza a internet, é provável que já tenha ouvido falar sobre endereços IP,
                                            mas você sabe o que eles realmente significam? Neste artigo,
                                            iremos desvendar o mundo dos IPs, especificamente os IPs Fixos, Dinâmicos e CGNAT,
                                            e explicar como eles afetam a sua experiência de conexão.<br /><br />

                                            <strong>O que é um endereço IP?</strong><br />
                                            Antes de mergulharmos nos diferentes tipos de IPs,
                                            vamos entender o conceito básico de um endereço IP.
                                            IP significa Protocolo de Internet e é uma sequência numérica que
                                            identifica um dispositivo (como um computador, smartphone ou roteador) conectado à internet.
                                            É como um "número de telefone" exclusivo para cada dispositivo na rede.<br /><br />

                                            <strong>IP Fixo: </strong><br />
                                            Um IP Fixo é um endereço IP permanente e único atribuído a um dispositivo.
                                            É como ter um endereço residencial fixo. Com um IP Fixo, seu dispositivo sempre
                                            terá o mesmo endereço IP quando você se conectar à internet.
                                            Isso pode ser útil em várias situações, como hospedagem de servidores,
                                            acesso remoto ou quando você precisa de uma identificação constante na rede.
                                            No entanto, os IPs Fixos geralmente são fornecidos por
                                            provedores de internet específicos e podem ter um custo adicional.<br /><br />

                                            <strong>IP Dinâmico: </strong><br />
                                            Ao contrário do IP Fixo, um IP Dinâmico é temporário e
                                            pode mudar sempre que você se conectar à internet.
                                            É como ter um endereço temporário em um hotel. Quando você se conecta,
                                            o provedor de internet atribui um IP disponível no momento. Quando você desconecta,
                                            o IP é liberado e pode ser usado por outro dispositivo posteriormente.
                                            Os IPs Dinâmicos são amplamente utilizados por provedores de internet,
                                            pois permitem uma alocação mais eficiente dos endereços IP,
                                            especialmente quando há um grande número de usuários.
                                            <br /><br />

                                            <strong>CGNAT (Carrier-Grade NAT): </strong><br />
                                            Com o crescente número de dispositivos conectados à internet,
                                            o espaço de endereços IP IPv4 (versão 4) está se esgotando.
                                            Para contornar esse problema, os provedores de internet adotaram uma solução chamada CGNAT.
                                            O CGNAT permite que vários dispositivos compartilhem o mesmo endereço IP público
                                            fornecido pelo provedor. Isso é semelhante a um condomínio em que várias
                                            residências compartilham o mesmo endereço postal externo. O CGNAT permite
                                            que mais dispositivos se conectem à internet usando um único IP público.
                                            No entanto, o CGNAT pode causar restrições em alguns serviços, como a
                                            impossibilidade de redirecionamento de portas, hospedar servidores ou de estabelecer conexões de entrada para determinadas aplicações.
                                            <br /><br />

                                            <strong>Conclusão: </strong><br />
                                            Agora você tem uma visão mais clara sobre a conexão à internet. Independentemente 
                                            do tipo de IP utilizado, nossa provedora Gigabyte Telecom garante serviços confiáveis e personalizados, 
                                            permitindo que nosso cliente desfrute de todos os benefícios que a internet tem a oferecer!
                                        </span>
                                    </div>
                                </div>
                            </Card.Body>
                        </div>
                    </Card>

                </div>
            </div>
            
            <div className="end"></div>
        </div>
    )
}
export default IPs;